import { NormalizeOAS, OASResponse } from 'fets';
import type openapi from '../openapi';
import { ApiClient } from '../fetsClient';
import { assertNever } from '../utils';

type Params = {
  courseGuid: string;
};

type Result = {
  id: number;
  timeTaken: number;
  completedAt: number | null;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createInitializeProgressTracking = (apiClient: ApiClient): ApiFunction => {
  const initializeProgressTracking = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient['/api/progress-tracking/initialize/{courseGuid}'].post({
      params: { courseGuid: params.courseGuid },
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return initializeProgressTracking;
};

type Response = OASResponse<NormalizeOAS<typeof openapi>, '/api/progress-tracking/initialize/{courseGuid}', 'post'>;

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const body = await response.json();
  return {
    id: body.id,
    timeTaken: body.timeTaken,
    completedAt: body.completedAt == null ? null : Number(body.completedAt),
  };
};
